module.exports = __webpack_public_path__ + "static/media/RBG_art_Ben_Nichols.821ee6e1.png";